const GIT_DIRECTORY_PATH = '/gitdirs';
const REPOS_DIRECTORY_PATH = '/src/projects';
const REPOS_SELECTED_FILENAME = '.selected';

export { GIT_DIRECTORY_PATH, REPOS_DIRECTORY_PATH, REPOS_SELECTED_FILENAME };
